// Custom Messages
export const esCustomMessages = {
    teamEfficiency: 'Eficiencia del equipo',
    teamMembers: 'Miembros del equipo',
    dashboard: 'Tablero',
    planning: 'Planificación',
    info: 'Informacion',
    profile: 'Perfil',
    language: 'Idioma',
    trend: 'Tendencia',
    volume: 'Volumen',
    myTeam: 'Mi equipo',
    allTeams: 'Todos los equipos',
    teamCalendar: 'Calendario del equipo',
    saveChanges: 'Guardar cambios',
    cancel: 'Cancelar',
    warehouse: 'Almacén De Café',
    startFreeTrial: 'Iniciar prueba gratuita',
    buyNow: 'Comprar ahora',
    getSource: 'Obtenga el código fuente en GitHub',
    demoInfo:
        'Esta aplicación de demostración está construida utilizando los siguientes componentes de Kendo UI for Vue.',
    firstName: 'Primer nombre',
    middleName: 'Segundo nombre',
    lastName: 'Apellido',
    email: 'Dirección de correo electrónico',
    phoneNumber: 'Número de teléfono',
    country: 'País',
    biography: 'Biografía corta',
    public: 'Incluir en directorio público',
    team: 'Equipo',
    employee: 'Empleado',
    contactName: 'Nombre de contacto',
    jobTitle: 'Título del trabajo',
    status: 'Estado',
    performance: 'Rendimiento',
    rating: 'Clasificación',
    engagement: 'Compromiso',
    budget: 'Presupuesto',
    contacts: 'Contactos',
    address: 'Dirección',
    phone: 'Teléfono',
    gridSearch: 'Buscar en todas las columnas ...',
    exportExcel: 'Exportar a Excel',
    exportPdf: 'Exportar a PDF'
};

// Kendo Vue Component Messages
export const esComponentMessages = {
    "datepicker": {
        "toggleCalendar": "Alternar calendario"
    },
    "calendar": {
        "today": "Hoy"
    },
    "dateinput": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "datetimepicker": {
        "date": "Fecha",
        "time": "Hora",
        "cancel": "Cancelar",
        "set": "Establecer"
    },
    "numerictextbox": {
        "increment": "Incrementar valor",
        "decrement": "Disminuir valor"
    },
    "timepicker": {
        "now": "AHORA",
        "set": "Establecer",
        "cancel": "Cancelar"
    },
    "grid": {
        "groupPanelEmpty": "Arrastre el título de una columna y suéltelo aquí para agrupar por ese criterio",
        "noRecords": "No hay datos disponibles.",
        "pagerFirstPage": "Ir a la primera página",
        "pagerPreviousPage": "Ir a la página anterior",
        "pagerNextPage": "Ir a la página siguiente",
        "pagerLastPage": "Ir a la última página",
        "pagerPage": "Página",
        "pagerOf": "de",
        "pagerItems": "ítems",
        "pagerInfo": "{0} - {1} de {2} ítems",
        "pagerItemsPerPage": "ítems por página",
        "filterEqOperator": "Es igual a",
        "filterNotEqOperator": "No es igual a",
        "filterIsNullOperator": "Es nulo",
        "filterIsNotNullOperator": "No es nulo",
        "filterIsEmptyOperator": "Está vacío",
        "filterIsNotEmptyOperator": "No está vacío",
        "filterStartsWithOperator": "Comienza con",
        "filterContainsOperator": "Contiene",
        "filterNotContainsOperator": "No contiene",
        "filterEndsWithOperator": "Termina en",
        "filterGteOperator": "Es mayor o igual que",
        "filterGtOperator": "Es mayor que",
        "filterLteOperator": "Es menor o igual que",
        "filterLtOperator": "Es menor o igual que",
        "filterIsTrue": "Sí",
        "filterIsFalse": "No",
        "filterBooleanAll": "(Todas)",
        "filterAfterOrEqualOperator": "Es posterior o igual a",
        "filterAfterOperator": "Es posterior",
        "filterBeforeOperator": "Es anterior",
        "filterBeforeOrEqualOperator": "Es anterior o igual a",
        "filterSubmitButton": "Filtrar",
        "filterClearButton": "Limpiar",
        "filterAndLogic": "Y",
        "filterOrLogic": "O",
        "filterTitle": "Filtros",
        "sortAscending": "Orden ascendente",
        "sortDescending": "Orden descendente"
    },
    "upload": {
        "cancel": "Cancelar",
        "dropFilesHere": "Arrastre los archivos aquí para subirlos",
        "select": "Seleccione...",
    },
};
